import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const PartnersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/partners" */
    'routes/Control/Partners/PartnersRoute'
  )
));

const PartnerPayoutsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/partner-payouts" */
    'routes/Control/Partners/PayoutsRoute'
  )
));

const PartnerCommissionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/partner-commissions" */
    'routes/Control/Partners/CommissionsRoute'
  )
));

const ReferralsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/referrals" */
    'routes/Control/Partners/ReferralsRoute'
  )
));

const IntegrationPartnersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/integration-partners" */
    'routes/Control/Partners/IntegrationsRoute'
  )
));

const UpdateIntegrationPartnerRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/update-integration-partner" */
    'routes/Control/Partners/UpdateIntegrationRoute'
  )
));

const IntegrationPartnerOptionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/integration-partner-options" */
    'routes/Control/Partners/IntegrationOptionsRoute'
  )
));

const PartnerDealsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/partner-deals" */
    'routes/Control/Partners/DealsRoute'
  )
));

const UpdatePartnerDealRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/update-partner-deal" */
    'routes/Control/Partners/UpdateDealRoute'
  )
));

const AgenciesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/agencies" */
    'routes/Control/Partners/AgenciesRoute'
  )
));

const PreviewAgencyDetailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/preview-agency-details" */
    'routes/Control/Partners/PreviewAgencyDetailsRoute'
  )
));

const AgencyOptionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/agency-options" */
    'routes/Control/Partners/AgencyOptionsRoute'
  )
));

const getControlPartnersRoutes = () => {
  return [
    {path: paths.getPathControlPartners(), component: PartnersRoute},
    {path: paths.getPathControlPartnerPayouts(), component: PartnerPayoutsRoute},
    {path: paths.getPathControlPartnerCommissions(":partnerId"), component: PartnerCommissionsRoute},
    {path: paths.getPathControlReferrals(), component: ReferralsRoute},

    {path: paths.getPathControlIntegrationPartners(), component: IntegrationPartnersRoute},
    {path: paths.getPathControlAddIntegrationPartner(), component: UpdateIntegrationPartnerRoute},
    {path: paths.getPathControlEditIntegrationPartner(":integrationId"), component: UpdateIntegrationPartnerRoute},
    {path: paths.getPathControlIntegrationPartnerOptions(), component: IntegrationPartnerOptionsRoute},

    {path: paths.getPathControlPartnerDeals(), component: PartnerDealsRoute},
    {path: paths.getPathControlAddPartnerDeal(), component: UpdatePartnerDealRoute},
    {path: paths.getPathControlEditPartnerDeal(":dealId"), component: UpdatePartnerDealRoute},

    {path: paths.getPathControlAgencies(), component: AgenciesRoute},
    {path: paths.getPathControlPrevewAgencyDetails(":agencyId"), component: PreviewAgencyDetailsRoute},
    {path: paths.getPathControlAgencyOptions(), component: AgencyOptionsRoute},
  ]
}



export { getControlPartnersRoutes };
